export default "__VITE_ASSET__BmjBSsPy__"